import { render, staticRenderFns } from "./MessageReply.vue?vue&type=template&id=7794545c&scoped=true"
import script from "./MessageReply.vue?vue&type=script&lang=js"
export * from "./MessageReply.vue?vue&type=script&lang=js"
import style0 from "./MessageReply.vue?vue&type=style&index=0&id=7794545c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7794545c",
  null
  
)

export default component.exports